import table from "./table.json";
import revokeChargingPermissionDialog from "./revoke-charging-permission-dialog.json";
import grantPermission from "./grant-permission.json";

export default {
  table,
  revokeChargingPermissionDialog,
  grantPermission,
};
